export default "__VITE_ASSET__BAnHiC1z__"